/**
 * mod(name, fn) — run one page feature in isolation.
 *
 * Everything on this site is one flat page script, so an uncaught throw inside
 * any feature stops every feature declared after it. That is not theoretical:
 * the scroll-reveal observer is one of those features, and when it does not run
 * the whole page stays at `opacity: 0` — a blank white screen caused by an
 * unrelated null reference twenty lines earlier.
 *
 * So every feature is registered through here. A feature that finds nothing to
 * do returns early; a feature that throws is logged with its name and the rest
 * of the page still works.
 *
 * The name is not decoration — it is the only thing that tells you WHICH
 * feature failed, from a console line in a browser you do not have.
 */
export function mod(name, fn) {
  try {
    fn();
  } catch (error) {
    // console.error rather than a silent catch: a swallowed failure is how a
    // feature stays broken for months.
    console.error(`[${name}]`, error);
  }
}

/**
 * Run fn once the DOM is parsed. The head templates load our bundle in <head>
 * without `defer`, so at execution time the body does not exist yet — every
 * feature has to wait.
 */
export function ready(fn) {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fn, { once: true });
  } else {
    fn();
  }
}
